import { lazy } from "react";
import Loadable from "../layouts/loader/Loadable";

import adminRouter from "./adminRouter";
import distributorRouter from "./distributorRouter";
import retailerRouter from "./retailerRouter";
import employeeRouter from "./employeeRouter";
// import businessRouter from "./businessRouter";
// import employeeRouter from "./employeeRouter";
// import superAdminRouter from "./superAdminRouter";
// import { Navigate } from "react-router-dom";

/*************Website-Start*******************/
const BlankLayout = Loadable(lazy(() => import("../layouts/BlankLayout")));
const Error = Loadable(lazy(() => import("../views/Web/Error")));
const Maintanance = Loadable(lazy(() => import("../views/Web/Maintanance")));
const Home = Loadable(lazy(() => import("../views/Web/pages/Home")));
const About = Loadable(lazy(() => import("../views/Web/pages/AboutUs")));
const Services = Loadable(lazy(() => import("../views/Web/pages/Services")));
const OurPartner  = Loadable(lazy(() => import("../views/Web/pages/OurPartner")));
const Career  = Loadable(lazy(() => import("../views/Web/pages/Career")));
const ContactUs  = Loadable(lazy(() => import("../views/Web/pages/Contact")));
// const BenefitUser = Loadable(lazy(() => import("../views/Web/pages/BenefitUser")));
// const BusinessWithUs  = Loadable(lazy(() => import("../views/Web/pages/BusinessWithUs")));
// const TermsConditions = Loadable(lazy(() => import("../views/Web/pages/TermsAndCondition")));
// const PrivacyPolicy = Loadable(lazy(() => import("../views/Web/pages/PrivacyPolicy")));
// const RefundPolicy = Loadable(lazy(() => import("../views/Web/pages/RefundPolicy")));
// const GrievanceRedressalPolicy = Loadable(lazy(() => import("../views/Web/pages/GrievanceRedressalPolicy")));
// const KYCAMLPolicy = Loadable(lazy(() => import("../views/Web/pages/KYCamlPolicy")));
const Login = Loadable(lazy(() => import("../views/Web/Login")));
const ForgotPassword = Loadable(lazy(() => import("../views/Web/ForgotPassword")));
// const LockScreen = Loadable(lazy(() => import("../views/Web/LockScreen")));
// const OtpVerification = Loadable(lazy(() => import("../views/Web/OtpVerification")));
const Signup = Loadable(lazy(() => import('../views/Web/Signup')));
/*************Website-End*******************/

/*****Routes******/
const ThemeRoutes = [
  {
    path: "/",
    key: 1,
    element: <BlankLayout />,
    children: [
      { path: "404", element: <Error /> },
      // { path: "*", element: <Navigate to="/404" /> },
      { path: "maintanance", element: <Maintanance /> },
      { path: "*", element: <Maintanance /> },
      { path: "/", element: <Home /> },
      { path: "about", element: <About /> },
      { path: "services", element: <Services /> },
      { path: 'partnerWithUs', element: <OurPartner /> },
      { path: 'career', element: <Career /> },
      { path: "contact", element: <ContactUs /> },
      { path: "login", element: <Login /> },
      { path: 'signup', element: <Signup /> },
      // { path: "benefitUser", element: <BenefitUser /> },
      // { path: "refundpolicy", element: <RefundPolicy /> },
      // { path: "privacypolicy", element: <PrivacyPolicy /> },
      // { path: "termsandcondition", element: <TermsConditions /> },
      { path: "forgotPassword", element: <ForgotPassword /> },
      // { path: "otpVerification", element: <OtpVerification /> },
      // { path: "lockscreen", element: <LockScreen /> },
      // { path: "KYC_AML_Policy", element: <KYCAMLPolicy /> },
      // { path: "Grievance_Redressal_Policy", element: <GrievanceRedressalPolicy /> },
    ],
  },  

  // SUPER ADMIN SCREEN
  // superAdminRouter,

  // AADMIN SCREEN
  adminRouter,
  
  // MASTER SCREEN
  // masterDistributorRouter,
  
  // SUPER DISTRIBUTOR SCREEN
  // superDistributorRouter,

  // DISTRIBUTOR SCREEN
  distributorRouter,

  // RETAILER SCREEN
  retailerRouter,
  
  // BUSINESS SCREEN
  // businessRouter,

  //EMPLOYE SCREEN
  employeeRouter,
];

export default ThemeRoutes;
